import "./layout.css";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import useAuth from "../hooks/use_auth";
import { useSelector } from "react-redux";
import LogoutModal from "../components/logout_modal";
import LoadingPrimary from "../assets/animations/loading_primary.svg";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { getUserProfile } = useAuth();

  const userProfile = useSelector((state) => state.app.userProfile);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      if (!userProfile) {
        getUserProfile();
      }
    } else {
      navigate("/login");
    }
  }, []);

  return (
    <div className="layout">
      <Sidebar />
      <div className="layout_body">
        <Header />
        <div
          className={`layout_app_body 
          ${
            location.pathname != "/dashboard" || location.pathname != "/courses"
              ? "layout_app_body_full_height"
              : ""
          }
          `}
        >
          {userProfile ? (
            children
          ) : (
            <div className="layout_loading">
              <img src={LoadingPrimary} alt="Loading..." />
            </div>
          )}
        </div>
      </div>
      <LogoutModal />
    </div>
  );
};

export default Layout;
